/// <reference types='google.maps' />
import { Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { DeviceListModalComponent } from 'libs/portal/src/modules/keepalive/components/map/device-list-modal/device-list-modal/device-list-modal.component';
import { FilterItem, FilterOptions } from 'libs/portal/src/modules/tools/filters/models';
import { GenericService } from 'libs/portal/src/services/generic/generic.service';
import { TitleService } from 'libs/portal/src/services/title/title.service';
import { ToolsService } from 'libs/portal/src/services/tools/tools.service';
import { UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from '@huge-monorepo/portal/config';
import { Routes } from '@huge-monorepo/portal/config';

declare const google: any;
declare const MarkerClusterer: any;

@Component({
  selector: 'app-mikrotik-map',
  templateUrl: './mikrotik-map.page.html',
  styleUrls: ['./mikrotik-map.page.scss'],
})
export class MikrotikMapPageComponent implements OnInit {
  @ViewChild('mapContainer', { static: false }) gmap: ElementRef;
  map: google.maps.Map;
  lat = -29.114501;
  lng = 25.411157;

  coordinates: google.maps.LatLng = new google.maps.LatLng(this.lat, this.lng);
  markerClusterer: any;
  deviceInfo: any[] = [];
  ScreenSize = ScreenSize;
  selectionEnabled = false;

  firstMapLoad = true;
  maploading = false;
  numClusters = 1;
  maxClusters = 15;
  minClusters = 1;
  activeInfoWindow: google.maps.InfoWindow;
  activeInfoMarkers: google.maps.Marker[] = [];
  currentSearch: string;

  showAllSignalStrength = false;
  showAllRingfence = false;
  // showDeviceStates: boolean = false;
  signalStrengthCircles: google.maps.Circle[] = [];
  ringfenceCircles: google.maps.Circle[] = [];
  stateCircles: google.maps.Circle[] = [];
  totalOffline = 0;
  requestingClusterData = false;

  mapOptions: google.maps.MapOptions = {
    center: this.coordinates,
    zoom: 6,
    scaleControl: true,
    streetViewControl: false,
    disableDoubleClickZoom: false,
    fullscreenControl: false,
    mapTypeControl: false,
    minZoom: 4,
    zoomControl: true,
  };

  filterOptions: FilterOptions = {
    showSearch: true,
    searchPlaceholder: 'Search for devices',
    // filterHint: "select filter",
    showClearChip: false,
  };

  aggregation = true;

  filterChips: FilterItem[] = [
    // {
    //   title: 'Status',
    //   value: 'status'
    // },
    // {
    //   title: 'Bundle',
    //   value: 'bundle'
    // },
    // {
    //   title: 'Terminal',
    //   value: 'terminal'
    // },
    // {
    //   title: 'Merchants',
    //   value: 'merchants'
    // },
    // {
    //   title: 'Last update',
    //   value: 'lastUpdate'
    // },
  ];

  circles: google.maps.Circle[] = [];
  markers: google.maps.Marker[] = [];
  deviceMapData: any[] = [];
  debounceTimeout: any;
  clustering = true;
  freezeMap = false;
  lastRefresh: string;

  mapBounds: google.maps.LatLngBoundsLiteral = {
    east: 41.7148679375,
    south: -37.47551721717827,
    west: 9.107446062500006,
    north: -20.01542582501192,
  };

  constructor(
    private titleService: TitleService,
    private genericService: GenericService,
    private endpoints: Endpoints,
    private dialog: MatDialog,
    private router: Router,
    private layoutService: LayoutService,
    private tools: ToolsService,
    private routeDictionary: Routes,
    private zone: NgZone,
    private auth: UserRightsService,
  ) {
    window['MapComponent'] = this;
    window['ViewDevice'] = this.ViewDevice;
    this.titleService.pageTitle = 'Maps';
  }

  ngOnInit() {
    this.maploading = true;
    const stopScrolling = false;
    setTimeout(() => {
      this.mapInitializer();
      // Custom scroll zoom logic
      const mapContainer = document.getElementById('map'); // Ensure this ID is correct
      if (mapContainer) {
        mapContainer.addEventListener('wheel', (event: WheelEvent) => this.tools.handleZoom(event, this.map));
      }
    });

    window.addEventListener('touchmove', handleTouchMove, {
      passive: false,
    });

    function handleTouchMove(e) {
      if (!stopScrolling) {
        return;
      }
      e.preventDefault();
    }
  }

  clearClusterer() {
    if (this.markerClusterer) {
      // this.markerClusterer.clearMarkers();
      this.markerClusterer.setMap(null);
    }
  }

  clearCircles() {
    if (this.circles == null) {
      return;
    }
    for (let i = 0; i < this.circles.length; i++) {
      this.circles[i].setMap(null);
      this.circles[i].setRadius(0);
    }
    this.circles = [];
  }

  clearMarkers() {
    this.clearClusterer();

    if (this.activeInfoWindow != null) {
      this.activeInfoWindow.close();
    }

    if (this.markers == null) {
      return;
    }

    for (let i = 0; i < this.markers.length; i++) {
      this.markers[i].setMap(null);
      this.markers[i].unbindAll();
    }

    this.markers = [];
  }

  toggleSelectionType() {
    this.selectionEnabled = !this.selectionEnabled;
  }

  setMapRefresh(interval: number) {
    this.totalOffline = 0;
    this.maploading = true;
    return setTimeout(() => {
      this.clearMarkers();
      this.clearCircles();

      if (this.map) {
        this.mapBounds = this.map.getBounds().toJSON();
      }

      this.GetDeviceMapData();

      this.lastRefresh = new Date().toLocaleString('en-ZA', { timeZone: 'Africa/Johannesburg' });
      this.freezeMap = true;

      // if(zoom >= 10) {
      //   this.aggregation = false;
      //   setTimeout( () => {

      //   });
      // } else {
      //   this.aggregation = true;
      //   if (this.numClusters > this.maxClusters) {
      //     this.numClusters = this.maxClusters;
      //   } else if (this.numClusters < this.minClusters) {
      //     this.numClusters = this.minClusters;
      //   }

      //   setTimeout( () => {
      //     this.GetClusterMapData(this.numClusters);
      //   });
      // }
    }, interval);
  }

  mapInitializer(): void {
    this.map = new google.maps.Map(this.gmap.nativeElement, this.mapOptions);

    const filterControl = document.getElementById('chip-filter') as HTMLElement;
    this.map.controls[google.maps.ControlPosition.TOP_LEFT].push(filterControl);

    // const mapTypeControl = document.getElementById(
    //   "map-type-control"
    // ) as HTMLElement;
    // this.map.controls[google.maps.ControlPosition.RIGHT_TOP].push(
    //   mapTypeControl
    // );

    this.map.addListener('bounds_changed', () => {
      if (this.freezeMap) {
        return;
      }

      if (this.maploading) {
        return;
      }

      this.maploading = true;
    });

    this.map.addListener('idle', () => {
      if (this.debounceTimeout != null) {
        clearTimeout(this.debounceTimeout);
      }

      if (this.freezeMap) {
        return;
      }

      if (this.requestingClusterData) {
        return;
      }
      this.debounceTimeout = this.setMapRefresh(150);
    });

    // this.GetClusterMapData(this.numClusters);
  }

  changeCluster(eve) {
    if (Number.isNaN(parseInt(eve.target.value))) {
      this.numClusters = 1;
      return;
    }

    if (this.numClusters > this.maxClusters) {
      this.numClusters = this.maxClusters;
    } else if (this.numClusters < this.minClusters) {
      this.numClusters = this.minClusters;
    }

    this.numClusters = parseInt(eve.target.value);
  }

  CreateDeviceMapMarker(deviceCluster: any): boolean {
    // console.log("DEVCLUST",deviceCluster);
    const BASE_PATH = 'assets/map-markers/';

    const state = true;

    const iconInfo = this.tools.GetBasicTowerMarkerInfo(deviceCluster.Tower.MNC, null, state, true);
    const marker = new google.maps.Marker({
      label: {
        text: `${deviceCluster.Devices.length}`,
        color: 'black',
        fontSize: '10pt',
        fontWeight: 'bold',
        className: '',
      },
      MarkerIndex: deviceCluster.MarkerIndex,
      markerId: this.markers.length,
      position: new google.maps.LatLng(deviceCluster.Lat, deviceCluster.Long),
      map: this.map,
      CSQ: deviceCluster.CSQ,
      Tower: deviceCluster.Tower,
      Radius: deviceCluster.Radius,
      Devices: deviceCluster.Devices,
      icon: BASE_PATH + iconInfo.icon,
    });

    this.markers.push(marker);
    // console.log("MARKERS", this.markers)
    return true;
  }

  // createDeviceWindowContent(marker: google.maps.Marker) : string {
  //   if (marker["Devices"] == null || marker["Devices"].length == 0) {
  //     // Invalid device list details
  //     return "Data Unavailable.";
  //   }
  //   let navUrl = "/Device/" + marker["Devices"][0].ID + "?cdr=false";
  //   if (marker["Devices"][0]["DeviceID"] != null && marker["Devices"][0]["DeviceID"] > 0) {
  //     navUrl += "&deviceid=" + marker["Devices"][0]["DeviceID"];
  //   }

  //   let network = this.tools.GetNetworkNameByMNC(marker["Tower"].MNC);
  //   let content = `
  //   <style>
  //     .gm-style-iw, .gm-style-iw-d{ height: 250px !important; max-height: 250px !important; }
  //   </style>
  //   <div id="content">
  //     <div id="siteNotice">
  //     </div>
  //     <h3 id="firstHeading" class="firstHeading">Tower ${marker["Tower"].CellID}</h3>
  //     <div id="bodyContent">
  //       <p><span class="bold">Country Code:</span> ${marker["Tower"].CountryCode}</p>
  //       <p><span class="bold">Cell ID:</span> ${marker["Tower"].CellID}</p>
  //       <p><span class="bold">LAC:</span> ${marker["Tower"].LAC}</p>
  //       <p><span class="bold">Network:</span> ${network}</p>
  //     </div>
  //     <div>
  //       <h4>Device:</h4>
  //       <p><span class="bold">Terminal ID:</span> ${marker["Devices"][0].Label} <a class="cursor pull-right" href="${navUrl}">View Details</a></p>
  //     </div>
  //   </div>`;
  //   return content;
  // }

  createDeviceListWindowContent(marker: google.maps.Marker): string {
    // console.log(marker)
    if (marker['Devices'] == null || marker['Devices'].length == 0) {
      // Invalid device list details
      return 'Data Unavailable.';
    }

    const network = this.tools.GetNetworkNameByMNC(marker['Tower'].MNC);
    let content = `
      <style>
        .gm-style-iw, .gm-style-iw-d{ height: 250px !important; max-height: 250px !important; }
      </style>
      <h3>Tower ${marker['Tower'].CellID}</h3>
      <div id="bodyContent">
        <p><span class="bold">Cell ID:</span> ${marker['Tower'].CellID}</p>
        <p><span class="bold">LAC:</span> ${marker['Tower'].LAC}</p>
        <p><span class="bold">Network:</span> ${network}</p>
      </div>
      <h4><u>Device(s):</u></h4>`;

    marker['Devices'].forEach((element: any, index: number) => {
      content +=
        `
      <div class="text-left">
        <p><span class="bold">${index + 1}:</span> ${element.Label} ` +
        (element.DeviceNum != null ? '(' + element.DeviceNum + ')' : '') +
        ` <a href="javascript:;" class="cursor pull-right" onClick="ViewDevice(${marker['Devices'][index].ID})">View Details</a></p>
      </div>`;
    });
    content += `<br />`;

    return content;
  }

  navToDetails(mikrotikID) {
    if (this.activeInfoWindow == null || this.activeInfoWindow['Devices']?.length <= 0) {
      return;
    }

    for (let i = 0; i < this.activeInfoWindow['Devices'].length; i++) {
      if (this.activeInfoWindow['Devices'][i]['ID'] == mikrotikID) {
        this.zone.run(() => {
          this.router.navigate([this.routeDictionary.MikrotikDeviceDetails], {
            state: {
              data: {
                CdrID: mikrotikID,
                KaID: null,
                refresh: true,
              },
            },
          });
          return;
        });
      }
    }
  }

  ViewDevice(mikrotikID) {
    setTimeout(() => {
      window['MapComponent'].navToDetails(mikrotikID);
    });
  }

  CreateDeviceMapRadius(deviceCluster: any) {
    const csq = deviceCluster.CSQ != null ? deviceCluster.CSQ : null;
    const radiusDistance = deviceCluster.Radius != null && deviceCluster.Radius > 0 ? deviceCluster.Radius : null;
    const distance = this.tools.CalculateRadiusDistanceBasedOnCSQ(csq, radiusDistance);

    const red = this.tools.GetNetworkColourByMNC(deviceCluster.Tower.MNC);
    const radius = new google.maps.Circle({
      strokeColor: red,
      strokeOpacity: 0.4,
      strokeWeight: 2,
      fillColor: red,
      fillOpacity: 0.1,
      map: this.map,
      center: new google.maps.LatLng(deviceCluster.Lat, deviceCluster.Long),
      radius: distance,
    });
    this.circles.push(radius);
  }

  GetDeviceMapData() {
    const deviceObj = {
      DeviceIds: [],
      StartTime: 0,
      EndTime: 0,
      LAC: null,
      CellID: null,
      Operator: null,
      Search: this.currentSearch,
      Count: 10,
      GroupID: this.auth.GetGroupID(),
      Bounds: {
        SW: {
          Lat: this.mapBounds.south,
          Long: this.mapBounds.west,
        },
        NE: {
          Lat: this.mapBounds.north,
          Long: this.mapBounds.east,
        },
      },
      IgnoreBounds: false,
    };

    this.genericService.POST(this.endpoints.GET_ADVANCED_MIKROTIK(this.auth.GetGroupID(), this.currentSearch != null ? this.currentSearch : ''), deviceObj).subscribe((results) => {
      const body = results['body'];
      console.log('body', body);
      if (body != null) {
        let mikrotikLocations = [];
        body.forEach((device) => {
          // console.log("looping device")
          if (device.Locations != null) {
            device.Locations.forEach((location) => {
              // console.log("looping locations")
              if (location.Tower != null) {
                if (!mikrotikLocations.some((e) => e.Device.id == device.id)) {
                  // Do not add multiple of the same device to the locations list, will enter if device not in list yet
                  mikrotikLocations.push({
                    ID: location.Tower.ID,
                    Lat: location.Tower.Lat,
                    Long: location.Tower.Long,
                    Timestamp: new Date(location.Timestamp).valueOf() / 1000, // Gets epoch time, divide by 1000 to convert from ms to s
                    Tower: location.Tower,
                    Device: device,
                  });
                } else if (mikrotikLocations.some((e) => e.Device.id == device.id && e.Timestamp < new Date(location.Timestamp).valueOf() / 1000)) {
                  // If Timestamp of new device is greater (newer) than existing device in list, replace with newer one
                  mikrotikLocations = mikrotikLocations.filter((e) => e.Device.id == device.id); // Remove existing (older) location from the list
                  mikrotikLocations.push({
                    ID: location.Tower.ID,
                    Lat: location.Tower.Lat,
                    Long: location.Tower.Long,
                    Timestamp: new Date(location.Timestamp).valueOf() / 1000, // Gets epoch time, divide by 1000 to convert from ms to s
                    Tower: location.Tower,
                    Device: device,
                  });
                }
                return;
              }
            });
          }
        });
        console.log('miktikloc', mikrotikLocations);

        const dupMap = {};

        for (let i = 0; i < mikrotikLocations.length; i++) {
          const temp = {
            MarkerIndex: 0,
            Lat: mikrotikLocations[i].Lat,
            Long: mikrotikLocations[i].Long,
            Tower: mikrotikLocations[i].Tower,
            Devices: [
              {
                Label: mikrotikLocations[i].Device.name,
                ID: mikrotikLocations[i].Device.id,
                Timestamp: this.tools.FormatDateTime(this.tools.ConvertEpochToDate(mikrotikLocations[i].Timestamp)),
              },
            ],
          };

          const center = new google.maps.LatLng(mikrotikLocations[i].Lat, mikrotikLocations[i].Long);
          const key = center.toString();

          // console.log(i, this.deviceMapData, temp, this.markers);
          if (this.deviceMapData.length == 0) {
            // No such location marker exists yet. Add new
            temp.MarkerIndex = 0;
            this.deviceMapData.push(temp);
            const success = this.CreateDeviceMapMarker(temp);
            // this.markers[0]["Devices"].push(temp.Devices[0]);
            if (success) {
              // console.log(success)
              // this.markers[0].setLabel(this.markers[0]["Devices"] != null ? this.markers[0]["Devices"].length.toString() : "1");
              dupMap[key] = temp;
            }
          } else {
            if (dupMap[key] != null) {
              // dupMap[key].Devices.push(temp.Devices[0]);
              // console.log(this.markers[dupMap[key].MarkerIndex], dupMap[key]);
              // console.log(temp, this.markers[dupMap[key].MarkerIndex]);
              this.markers[dupMap[key].MarkerIndex]['Devices'].push(temp.Devices[0]);
              this.markers[dupMap[key].MarkerIndex].setLabel(this.markers[dupMap[key].MarkerIndex]['Devices'].length.toString());
            } else {
              // No such location marker exists yet. Add new
              temp.MarkerIndex = this.markers.length;
              this.deviceMapData.push(temp);
              const success = this.CreateDeviceMapMarker(temp);
              if (success) {
                // this.markers[temp.MarkerIndex]["Devices"].push(temp.Devices[0]);
                // this.markers[temp.MarkerIndex].setLabel(this.markers[temp.MarkerIndex]["Devices"].length.toString());
                dupMap[key] = temp;
              }
            }
          }
        }

        for (let i = 0; i < this.markers.length; i++) {
          // For each marker create the content window
          const infowindow = new google.maps.InfoWindow();
          google.maps.event.addListener(infowindow, 'closeclick', () => {
            this.closeInfoWindow();
          });

          google.maps.event.addListener(
            this.markers[i],
            'rightclick',
            ((marker: google.maps.Marker) => {
              return () => {
                if (this.activeInfoWindow != null) {
                  this.activeInfoWindow.close();
                }

                for (let i = 0; i < this.circles.length; i++) {
                  const radiusCenter = this.circles[i].getCenter();
                  const markerCenter = marker.getPosition();
                  if (radiusCenter.toString() == markerCenter.toString()) {
                    this.circles[i].setMap(null);
                    this.circles.splice(i, 1);
                    return;
                  }
                }
              };
            })(this.markers[i]),
          );

          google.maps.event.addListener(
            this.markers[i],
            'click',
            ((marker: google.maps.Marker) => {
              return () => {
                if (this.activeInfoWindow != null) {
                  this.activeInfoWindow.close();
                }

                let sameMarkerClicked = false;
                for (let i = 0; i < this.activeInfoMarkers.length; i++) {
                  if (marker == this.activeInfoMarkers[i]) {
                    this.activeInfoWindow.close();

                    for (let i = 0; i < this.circles.length; i++) {
                      const radiusCenter = this.circles[i].getCenter();
                      const markerCenter = marker.getPosition();
                      if (radiusCenter.toString() == markerCenter.toString()) {
                        this.circles[i].setMap(null);
                        this.circles.splice(i, 1);
                        break;
                      }
                    }

                    this.activeInfoMarkers.splice(i, 1);
                    sameMarkerClicked = true;
                    break;
                  }
                }

                if (!sameMarkerClicked) {
                  let content = ``;
                  content = this.createDeviceListWindowContent(marker);

                  infowindow.setOptions({
                    content: content,
                    maxWidth: 400,
                    minWidth: 300,
                    shouldFocus: true,
                    disableAutoPan: true,
                  });

                  infowindow['Devices'] = marker['Devices'];

                  const center = marker.getPosition().toJSON();
                  const tmp = {
                    MarkerIndex: marker['MarkerIndex'],
                    Lat: center.lat,
                    Long: center.lng,
                    Tower: marker['Tower'],
                    Radius: marker['Radius'],
                    Devices: marker['Devices'],
                    CSQ: marker['CSQ'],
                  };

                  if (!this.selectionEnabled) {
                    this.clearCircles();
                    this.CreateDeviceMapRadius(tmp);
                    infowindow.open(this.map, marker);
                    this.activeInfoWindow = infowindow;
                  } else {
                    this.CreateDeviceMapRadius(tmp);
                  }
                  this.activeInfoMarkers.push(marker);
                }
              };
            })(this.markers[i]),
          );
        }

        if (!this.clustering) {
          this.clearClusterer();
        } else {
          this.setDevicesClusterer();
        }

        this.maploading = false;
      } else {
        this.maploading = false;
      }
    });
    //   Search: this.currentSearch,
    //   IgnoreBounds: this.currentSearch != null && this.currentSearch.length > 0 ? true : false,
    //   Bounds: {
    //     SW: {
    //       Lat: this.mapBounds.south,
    //       Long: this.mapBounds.west,
    //     },
    //     NE: {
    //       Lat: this.mapBounds.north,
    //       Long: this.mapBounds.east,
    //     },
    //   },
    // }, true).subscribe((results: any) => {
    //   if (results["body"] != null && results["body"]["Locations"] != null && results["body"]["Locations"].length > 0) {
    //     // console.log("body", results["body"]);
    //     let data = results["body"].Locations;
    //     // console.log("data",data)
    //     this.deviceMapData = [];
    //     let dupMap = {};

    // for (let i = 0; i < data.length; i++) {
    //   let temp = {
    //     MarkerIndex: 0,
    //     Lat: data[i].Lat,
    //     Long: data[i].Long,
    //     Tower: data[i].Tower,
    //     CSQ: data[i].CSQ,
    //     Radius: data[i].Radius,
    //     Devices: [{
    //       "Label": data[i].Label,
    //       "ID": data[i].ID,
    //       "DeviceID": data[i].DeviceID,
    //       "DeviceNum": data[i].DeviceNum,
    //       "Timestamp": data[i].Timestamp,
    //       "LastSeen": data[i].LastSeen,
    //       "Today": data[i].Today,
    //       "Yesterday": data[i].Yesterday,
    //       "LastTwelve": data[i].LastTwelve,
    //     }],
    //   };

    //   let center = new google.maps.LatLng(data[i].Lat, data[i].Long);
    //   let key = center.toString();

    //   // console.log(i, this.deviceMapData, temp, this.markers);
    //   if (this.deviceMapData.length == 0) {
    //     // No such location marker exists yet. Add new
    //     temp.MarkerIndex = 0;
    //     this.deviceMapData.push(temp);
    //     let success = this.CreateDeviceMapMarker(temp);
    //     // this.markers[0]["Devices"].push(temp.Devices[0]);
    //     if (success) {
    //       // this.markers[0].setLabel(this.markers[0]["Devices"] != null ? this.markers[0]["Devices"].length.toString() : "1");
    //       dupMap[key] = temp;
    //     }
    //   } else {
    //     if (dupMap[key] != null) {
    //       // dupMap[key].Devices.push(temp.Devices[0]);
    //       // console.log(this.markers[dupMap[key].MarkerIndex], dupMap[key]);
    //       // console.log(temp, this.markers[dupMap[key].MarkerIndex]);
    //       this.markers[dupMap[key].MarkerIndex]["Devices"].push(temp.Devices[0]);
    //       this.markers[dupMap[key].MarkerIndex].setLabel(this.markers[dupMap[key].MarkerIndex]["Devices"].length.toString());
    //     } else {
    //       // No such location marker exists yet. Add new
    //       temp.MarkerIndex = this.markers.length;
    //       this.deviceMapData.push(temp);
    //       let success = this.CreateDeviceMapMarker(temp);
    //       if (success) {
    //         // this.markers[temp.MarkerIndex]["Devices"].push(temp.Devices[0]);
    //         // this.markers[temp.MarkerIndex].setLabel(this.markers[temp.MarkerIndex]["Devices"].length.toString());
    //         dupMap[key] = temp;
    //       }
    //     }
    //   }
    // }

    //   for (let i = 0; i < this.markers.length; i++) {
    //     // For each marker create the content window
    //     let infowindow = new google.maps.InfoWindow();
    //     google.maps.event.addListener(infowindow, 'closeclick', () => {
    //       this.closeInfoWindow();
    //     });

    //     google.maps.event.addListener(
    //       this.markers[i],
    //       "rightclick",
    //       ((marker: google.maps.Marker, i) => {
    //         return () => {
    //           if (this.activeInfoWindow != null) {
    //             this.activeInfoWindow.close();
    //           }

    //           for(let i = 0; i < this.circles.length; i++) {
    //             let radiusCenter = this.circles[i].getCenter();
    //             let markerCenter = marker.getPosition();
    //             if (radiusCenter.toString() == markerCenter.toString()) {
    //               this.circles[i].setMap(null);
    //               this.circles.splice(i, 1);
    //               return;
    //             }
    //           }
    //         };
    //       })(this.markers[i])
    //     );

    //     google.maps.event.addListener(
    //       this.markers[i],
    //       "click",
    //       ((marker: google.maps.Marker, i) => {
    //         return () => {
    //           if (this.activeInfoWindow != null) {
    //             this.activeInfoWindow.close();
    //           }

    //           let sameMarkerClicked = false;
    //           for (let i = 0; i < this.activeInfoMarkers.length; i++) {
    //             if (marker == this.activeInfoMarkers[i]) {
    //               this.activeInfoWindow.close();

    //               for(let i = 0; i < this.circles.length; i++) {
    //                 let radiusCenter = this.circles[i].getCenter();
    //                 let markerCenter = marker.getPosition();
    //                 if (radiusCenter.toString() == markerCenter.toString()) {
    //                   this.circles[i].setMap(null);
    //                   this.circles.splice(i, 1);
    //                   break;
    //                 }
    //               }

    //               this.activeInfoMarkers.splice(i, 1);
    //               sameMarkerClicked = true;
    //               break;
    //             }
    //           }

    //           if (!sameMarkerClicked) {
    //             let content = ``;
    //             content = this.createDeviceListWindowContent(marker);

    //             infowindow.setOptions({
    //               content: content,
    //               maxWidth: 400,
    //               minWidth: 300,
    //               shouldFocus: true,
    //               disableAutoPan: true,
    //             });

    //             infowindow["Devices"] = marker["Devices"];

    //             let center = marker.getPosition().toJSON();
    //             let tmp = {
    //               MarkerIndex: marker["MarkerIndex"],
    //               Lat: center.lat,
    //               Long: center.lng,
    //               Tower: marker["Tower"],
    //               Radius: marker["Radius"],
    //               Devices: marker["Devices"],
    //               CSQ: marker["CSQ"],
    //             };

    //             if (!this.selectionEnabled) {
    //               this.clearCircles();
    //               this.CreateDeviceMapRadius(tmp);
    //               infowindow.open(this.map, marker);
    //               this.activeInfoWindow = infowindow;
    //             } else {
    //               this.CreateDeviceMapRadius(tmp);
    //             }
    //             this.activeInfoMarkers.push(marker);
    //           }
    //         };
    //       })(this.markers[i])
    //     );

    //   }
    // }
    // if (!this.clustering) {
    //   this.clearClusterer();
    // } else {
    //   this.setDevicesClusterer();
    // }

    //   if (this.showAllSignalStrength) {
    //     this.toggleAllSignalStrength(this.showAllSignalStrength);
    //   }
    //   if (this.showAllRingfence) {
    //     this.toggleAllRingfence(this.showAllRingfence);
    //   }
    //   // if (this.showDeviceStates) {
    //   //   this.toggleDeviceStates(this.showDeviceStates);
    //   // }
    //   this.maploading = false;
    // }, (err) => {
    //   this.maploading = false;
    // });
  }

  // ClusterMapCall(numClusters: number): Observable<Object> {
  //   return ;
  // }

  // OptimiseClusterAmount(weight: number): number {
  //   let clusters: number;
  //   switch (true) {
  //     case (weight >= 100):
  //       clusters = 15;
  //       break;
  //     case (weight >= 70):
  //       clusters = 10;
  //       break;
  //     case (weight >= 50):
  //       clusters = 7;
  //       break;
  //     case (weight >= 30):
  //       clusters = 5;
  //       break;
  //     case (weight >= 20):
  //       clusters = 3;
  //       break;
  //     default:
  //       clusters = 1;
  //       break;
  //   }
  //   return clusters;
  // }

  // GetClusterMapData(numClusters: number) {
  //   this.deviceMapData = [];
  //   let data = null;
  //   this.requestingClusterData = true;
  //   this.genericService.POST(this.endpoints.GET_DEVICE_CLUSTER_MAP, {
  //     Clusters: numClusters,
  //     IgnoreBounds: true,
  //     Bounds: {
  //       SW: {
  //         Lat: this.mapBounds.south,
  //         Long: this.mapBounds.west,
  //       },
  //       NE: {
  //         Lat: this.mapBounds.north,
  //         Long: this.mapBounds.east,
  //       },
  //     },
  //   }, true).subscribe((results: any) => {
  //     data = results["body"].Locations;
  //     console.log(results);
  //     if (data != null && data.length > 0) {
  //       if (data.length == 1 && this.firstMapLoad) {
  //         this.numClusters = this.OptimiseClusterAmount(data[0].Weight);
  //         this.GetClusterMapData(this.numClusters);
  //       } else {
  //         data.forEach((cluster: any, index: number) => {
  //           let marker = new google.maps.Marker({
  //             position: { lat: cluster.Lat, lng: cluster.Long },
  //             map: this.map,
  //             icon: "https://unpkg.com/@googlemaps/markerclustererplus@1.0.3/images/m3.png",
  //             label: {
  //               text: cluster.Weight.toString(),
  //               color: "white",
  //               fontSize: "11pt",
  //               fontWeight: "bold",
  //               className: null
  //             },
  //           });

  //           // google.maps.event.addListener(
  //           //   marker,
  //           //   "click",
  //           //   ((marker, i) => {
  //           //     return () => {

  //           //       console.log("clicked");
  //           //       // infowindow.setContent(
  //           //       //   this.buildContentString(this.info[i])
  //           //       // );
  //           //       // infowindow.open(this.map, marker);
  //           //     };
  //           //   })(marker, index)
  //           // );

  //           // this.info.push(this.getRandomString(10));
  //           this.markers.push(marker);
  //         });
  //       };
  //     }
  //     this.maploading = false;
  //     this.firstMapLoad = false;
  //     this.requestingClusterData = false;
  //   }, (err) => {
  //     this.maploading = false;
  //     this.firstMapLoad = false;
  //   });
  // }

  closeInfoWindow() {
    if (this.activeInfoWindow) {
      this.activeInfoWindow.close();
    }

    this.activeInfoWindow = null;
  }

  setDevicesClusterer(): void {
    const styles = [
      MarkerClusterer.withDefaultStyle({
        width: 30,
        height: 30,
        url: '../assets/img/Group 9.png',
        textColor: '#ffffff',
        textSize: 10,
      }),
      // MarkerClusterer.withDefaultStyle({
      //   width: 45,
      //   height: 45,
      //   url: "../assets/icon/marker-pinlet-45.png",
      //   textColor: "#ffffff",
      //   textSize: 11,
      // }),
      // MarkerClusterer.withDefaultStyle({
      //   width: 60,
      //   height: 60,
      //   url: "../assets/icon/marker-pinlet-60.png",
      //   textColor: "#ffffff",
      //   textSize: 12,
      // }),
      // MarkerClusterer.withDefaultStyle({
      //   width: 75,
      //   height: 75,
      //   url: "../assets/icon/marker-pinlet-75.png",
      //   textColor: "#ffffff",
      //   textSize: 13,
      // }),
    ];

    this.clearClusterer();

    this.markerClusterer = new MarkerClusterer(this.map, this.markers, {
      gridSize: 30,
      maxZoom: 14,
      styles: styles,
      zoomOnClick: true,
      clusterClass: undefined,
      minimumClusterSize: 2,
      ignoreHiddenMarkers: true,
    });

    this.markerClusterer.setCalculator((markers) => {
      let total = 0;
      markers.forEach((element) => {
        total += element['Devices'] != null ? element['Devices'].length : 0;
      });

      return {
        text: total.toString(),
        index: 0,
      };
    });

    this.markerClusterer.repaint();
  }

  async showDeviceListModal(deviceIds: number[]) {
    this.dialog.open(DeviceListModalComponent, {
      data: { deviceIds: deviceIds },
    });
  }

  searchSubmit(value: string): void {
    this.maploading = true;
    this.totalOffline = 0;
    this.clearMarkers();
    this.clearCircles();
    this.currentSearch = value;
    this.deviceMapData = [];
    if (value.length > 0) {
      this.freezeMap = true;
      this.GetDeviceMapData();
    } else {
      this.freezeMap = false;
      this.setMapRefresh(150);
    }
  }

  searchValueChanged(): void {}

  filterToggled(): void {}

  toggleDeviceCluster() {
    this.clustering = !this.clustering;

    if (!this.clustering) {
      this.clearClusterer();
    } else {
      this.setDevicesClusterer();
    }
  }

  filtersCleared(): void {}

  toggleAllSignalStrength(toggle) {
    if (toggle) {
      // this.clearCircles();
      for (let i = 0; i < this.markers.length; i++) {
        const exists = this.signalStrengthCircles.findIndex((t) => t['towerId'] == this.markers[i]['Tower'].CellID);
        if (exists == -1) {
          // let csq = tmp.CSQ != null ? tmp.CSQ : null;
          //   let radiusDistance = tmp.Radius != null && tmp.Radius > 0 ? tmp.Radius : null;
          const distance = this.tools.CalculateRadiusDistanceBasedOnCSQ(this.markers[i]['CSQ'], this.markers[i]['Radius']);

          const red = this.tools.GetNetworkColourByMNC(this.markers[i]['Tower'].MNC);
          const radius = new google.maps.Circle({
            strokeColor: red,
            strokeOpacity: 0.4,
            strokeWeight: 2,
            fillColor: red,
            fillOpacity: 0.1,
            map: this.map,
            center: this.markers[i].getPosition(),
            radius: distance,
            towerId: this.markers[i]['Tower'].CellID,
          });

          this.signalStrengthCircles.push(radius);
        }
      }
    } else {
      if (this.signalStrengthCircles == null) {
        this.signalStrengthCircles = [];
        return;
      }
      for (let i = 0; i < this.signalStrengthCircles.length; i++) {
        this.signalStrengthCircles[i].setMap(null);
        this.signalStrengthCircles[i].setRadius(0);
      }
      this.signalStrengthCircles = [];
    }
  }

  // toggleDeviceStates(toggle) {
  //   if (toggle) {
  //     for (let i = 0; i < this.markers.length; i++) {
  //       const marker = this.markers[i];

  //       let online = false;
  //       let lastTwelve = false;
  //       let yesterday = false;
  //       for (let j = 0; j < marker["Devices"].length; j++) {
  //         online = marker["Devices"][j].Today;
  //         lastTwelve = marker["Devices"][j].LastTwelve;
  //         yesterday = marker["Devices"][j].Yesterday;
  //       }

  //       let jsonPosition = marker.getPosition().toJSON();
  //       let center = new google.maps.LatLng(jsonPosition.lat, jsonPosition.lng);
  //       // let red = "#697479";
  //       let colour = "#";
  //       if (online && lastTwelve) {
  //         // Online within 12 hours
  //         colour += "7EDC52"; // green
  //       } else if (online && !lastTwelve) {
  //         // Online more than 12 hours ago
  //         colour += "666666"; // grey
  //       } else if (yesterday) {
  //         // Offline device
  //         colour += "697479"; // red
  //       }

  //       let radius = new google.maps.Circle({
  //         strokeColor: colour,
  //         strokeOpacity: 0.8,
  //         strokeWeight: 2,
  //         fillColor: colour,
  //         fillOpacity: 0.6,
  //         map: this.map,
  //         center: center,
  //         radius: 100,
  //       });

  //       this.stateCircles.push(radius);
  //     };
  //   } else {
  //     if (this.stateCircles == null) {
  //       return;
  //     }
  //     for (let i = 0; i < this.stateCircles.length; i++) {
  //       this.stateCircles[i].setMap(null);
  //       this.stateCircles[i].setRadius(0);
  //     }
  //     this.stateCircles = [];
  //   }
  // }

  // toggleAllRingfence(toggle) {
  //   if (toggle) {
  //     for (let i = 0; i < this.markers.length; i++) {
  //       let exists = this.ringfenceCircles.findIndex(t => t["towerId"] == this.markers[i]["Tower"].CellID);
  //       if (exists == -1) {
  //         let red = "#697479";
  //         let radius = new google.maps.Circle({
  //           strokeColor: red,
  //           strokeOpacity: 0.4,
  //           strokeWeight: 2,
  //           fillColor: red,
  //           fillOpacity: 0.1,
  //           map: this.map,
  //           center: this.markers[i].getPosition(),
  //           radius: this.markers[i]["Radius"],
  //           towerId: this.markers[i]["Tower"].CellID
  //         });
  //         this.ringfenceCircles.push(radius);
  //       }
  //     };
  //   } else {
  //     if (this.ringfenceCircles == null) {
  //       this.ringfenceCircles = [];
  //       return;
  //     }
  //     for (let i = 0; i < this.ringfenceCircles.length; i++) {
  //       this.ringfenceCircles[i].setMap(null);
  //       this.ringfenceCircles[i].setRadius(0);
  //     }
  //     this.ringfenceCircles = [];
  //   }
  // }
}
